import React, { Component } from 'react';
import { Collapse, Table } from 'reactstrap';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import UserPhoto from '../../UserPhoto/UserPhoto';
import moment from 'moment';
import { Consumer } from '../../../Context/Context-Menu-Acesso-Rapido/Context-Menu-Acesso-Rapido';

class VinculoPedido extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.removerVinculo = this.removerVinculo.bind(this);
        this.paymentBadgeType = this.paymentBadgeType.bind(this);

        this.state = {
            isOpen: true,
            isLoading: this.props.vinculo.value ? true : false,
            flagBusca: this.props.vinculo.value,
            dadosPedido: {}
        }
        this.configurations = new Configurations();
    }

    componentDidMount() {
        if (this.state.flagBusca) {
            this.setState({ isLoading: true })
            axios.get(this.configurations.apiBasePath + `/busca?query=P${this.props.vinculo.value}`)
                .then(resp => {
                    this.setState({ dadosPedido: resp.data.orders[0] })
                }).finally(() => this.setState({ isLoading: false }));
        }
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    toggleCollapse() {
        if (this.state.flagBusca) this.setState({ isOpen: !this.state.isOpen })
    }

    removerVinculo() {
        this.props.remover(this.props.index);
    }

    paymentBadgeType(status) {
        switch (status) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "Baixa Manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    render() {
        const {
            idPedido,
            // idTipoPedido,
            tipoPedido,
            nomeSolicitante,
            valorPago,
            dtCriacao,
            // idStatusPedido,
            statusPedido,
        } = this.state.dadosPedido;
        return (
            <Consumer>
                {({ toggleMenuAcessoRapido }) => {
                    return (
                        <div className="card rounded card-vinculo vinculo-pedido">
                            <div className={`card-header cursor-pointer ${this.state.isOpen ? '' : 'rounded'}`}>
                                <div className="row no-gutters align-items-center">
                                    <div className="col-9">
                                        <form className="form-inline" action="" method="POST">
                                            <span className="badge badge-primary mr-3">{`PEDIDO`}</span>
                                            {this.state.flagBusca ? (
                                                <h5 className="m-0 font-weight-bold">{idPedido} - {nomeSolicitante}</h5>
                                            ) : (
                                                    <AsyncTypeahead
                                                        id="mainSearch"
                                                        isLoading={this.state.isLoading}
                                                        className="ebs-typeahead w-75"
                                                        onChange={(s) => {
                                                            if (s && s.length > 0) {
                                                                this.setState({
                                                                    isOpen: true,
                                                                    dadosPedido: s[0],
                                                                    flagBusca: true
                                                                }, () => this.props.atualizar(this.props.index, this.state.dadosPedido.idPedido))
                                                            }
                                                        }}
                                                        labelKey={(option) => {
                                                            if (option) {
                                                                switch (option.type) {
                                                                    case 0:
                                                                        return `P${option.idPedido.toString()}`;
                                                                    default:
                                                                        return '';
                                                                }
                                                            } else {
                                                                return option;
                                                            }
                                                        }
                                                        }
                                                        renderMenuItemChildren={(option, props, idx) => (
                                                            (option.idPedido) && (
                                                                <div className="ebs-typeahead-order-item">
                                                                    <div className="mr-2"><UserPhoto src={`${this.configurations.apiBasePath}/minhas-informacoes/foto/${option.codMembro.toString()}`}></UserPhoto></div>
                                                                    &nbsp;Pedido&nbsp;
                                        <Highlighter search={props.text.substr(1, props.text.length)}>
                                                                        {option.idPedido ? option.idPedido.toString() : ''}
                                                                    </Highlighter>
                                                                    &nbsp;/ {option.nomeSolicitante}&nbsp;<small>({option.codMembro})</small>
                                                                    &nbsp;/&nbsp;<span className={`badge badge-${this.paymentBadgeType(option.statusPagamento)}`}>{option.statusPagamento}</span>
                                                                </div>)
                                                        )}
                                                        delay={400}
                                                        emptyLabel="Nenhum resultado encontrado"
                                                        searchText="Procurando..."
                                                        promptText="Digite para procurar..."
                                                        minLength={2}
                                                        placeholder={`Insira "p" + número do pedido (ex: p1234567)`}
                                                        onSearch={query => {
                                                            this.setState({ isLoading: true });
                                                            axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                                                                .then(resp => {
                                                                    if (resp.data && (resp.data.orders || resp.data.users)) {
                                                                        this.setState({
                                                                            isLoading: false,
                                                                            options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users
                                                                        });
                                                                    }
                                                                });
                                                        }}
                                                        options={this.state.options}
                                                    />
                                                )}
                                        </form>
                                    </div>
                                    <div className="col-2 text-center">
                                        <button onClick={() => toggleMenuAcessoRapido(true, null, idPedido, "pedido")} className="btn btn-sm btn-outline-primary">+ detalhes</button>
                                    </div>
                                    <div className="col-1 text-right">
                                        <i onClick={this.removerVinculo} className={`far fa-trash-alt text-danger icone-remover ${this.props.pedidoFinalizado ? 'd-none' : ''}`}></i>
                                    </div>
                                </div>
                            </div>
                            <Collapse isOpen={this.state.isOpen}>
                                <div className="card-body p-2">
                                    <div className="row no-gutters">
                                        {this.state.flagBusca && (
                                            <div className="col-12 py-2">
                                                {this.state.isLoading ? (
                                                    <div className="row no-gutters">
                                                        <div className="col-12 py-3 text-center">
                                                            <div className="spinner-border text-primary" role="status" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                        <div className="row no-gutters">
                                                            <div className="col-12">
                                                                <Table bordered responsive size="sm">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Pedido</th>
                                                                            <th>Tipo</th>
                                                                            <th>Solicitante</th>
                                                                            <th>Valor Pago</th>
                                                                            <th>Dt. pedido</th>
                                                                            <th>Status pedido</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr className="cursor-pointer" onClick={() => toggleMenuAcessoRapido(true, null, idPedido, "pedido")}>
                                                                            <td>{idPedido}</td>
                                                                            <td>{tipoPedido}</td>
                                                                            <td>{nomeSolicitante}</td>
                                                                            <td>{valorPago ? <span>R$ {valorPago.toFixed(2).replace('.', ',')}</span> : '-'}</td>
                                                                            <td>{moment(dtCriacao).format("DD/MM/YY HH:mm")}</td>
                                                                            <td>{statusPedido}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    )
                }}
            </Consumer>
        )
    }
}

export default VinculoPedido;